export default __webpack_public_path__ + "static/media/graph.1caed30d.svg";